import { AUTH_ACTION_TYPE } from 'enums';
import { t } from 'services/i18n.service';
import { useContext } from 'react';
import { createHtml } from 'utils/helpers';
import { AuthPageContext } from '../AuthActionsWrapper';
import CheckBox from 'components/common/inputs/CheckBox';
import { ATTRIB } from 'constants/test';

const PrivacyConsentControl = ({ showTocError }: { showTocError: boolean }) => {
  const {
    state: { hasAcceptedTerms },
    dispatch
  } = useContext(AuthPageContext);

  const checkboxTitle = createHtml(
    t('auth_page.i_accept_the_privacy_policy_and_the_terms_and_conditions')
  );

  return (
    <div className='flex flex-col ~gap-1.5/4 privacy-consent-links ~my-2/4'>
      <CheckBox
        id='input_toc'
        text={checkboxTitle as JSX.Element}
        checked={hasAcceptedTerms}
        onChange={({ target: { checked: value } }) =>
          dispatch?.({
            type: AUTH_ACTION_TYPE.UPDATE_HAS_ACCEPTED_TERMS,
            value
          })
        }
        dims='min-w-4 ~w-4/5 min-h-4 ~h-4/5'
        inputStyles='~text-xs/sm'
        className='inline-flex items-start ~gap-1.5/2 cursor-pointer'
        data-testid={ATTRIB.TEST.PRIVACY_CONSENT_CHECKBOX}
      />
      {showTocError && !hasAcceptedTerms && (
        <p className='~text-[0.55rem]/xs text-red-600'>
          {t(
            'auth_page.please_accept_the_terms_and_conditions_and_privacy_policy_first'
          )}
        </p>
      )}
      <p className='text-[0.55rem] sm:text-xs text-primary-900 dark:text-primary-dark-500 text-pretty'>
        {createHtml(
          t(
            'auth_page.focus_bear_is_responsible_for_the_processing_of_your_personal_data'
          )
        )}
      </p>
    </div>
  );
};

export default PrivacyConsentControl;
